<template>
  <div :class="$style.formTitle" data-cy="FormTitle"><slot /></div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.formTitle {
  padding-top: $space-100;
  padding-bottom: $space-100;

  @include heading-2;
}
</style>
<script setup lang="ts"></script>
